"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToCasaZone = convertToCasaZone;
exports.getProvinceFullName = getProvinceFullName;
exports.getProvinceAndState = getProvinceAndState;
exports.currentStateHasMainCity = currentStateHasMainCity;
exports.isMainCity = isMainCity;
exports.getMainCityStateShortName = getMainCityStateShortName;
exports.getMainCityList = getMainCityList;
exports.parseLocation = parseLocation;
exports.isFranceProvince = isFranceProvince;
exports.NapoliMainDistricts = exports.MilanoMainDistricts = exports.TorinoMainDistricts = exports.CATEGORY_TYPE = exports.CITY_IT = exports.PROVINCE_IT = exports.provinceList = exports.stateListFromAPI = void 0;

/*
 * CasaOldLocationHelper:
 * USED ONLY FOR OLD SEO URL -- Will be deprecated with the full passage to the new url
 */
var stateList = ['Abruzzo', 'Basilicata', 'Calabria', 'Campania', 'Emilia-Romagna', 'Friuli-Venezia Giulia', 'Lazio', 'Liguria', 'Lombardia', 'Marche', 'Molise', 'Piemonte', 'Puglia', 'Sardegna', 'Sicilia', 'Toscana', 'Trentino-Alto Adige', 'Umbria', 'Valle d\'Aosta', 'Valle d Aosta', 'Veneto'];
var stateListFromAPI = ['Abruzzo', 'Basilicata', 'Calabria', 'Campania', 'Emilia-romagna', 'Friuli-venezia giulia', 'Lazio', 'Liguria', 'Lombardia', 'Marche', 'Molise', 'Piemonte', 'Puglia', 'Sardegna', 'Sicilia', 'Toscana', 'Trentino-alto adige', 'Umbria', 'Valle d\'aosta', 'Valle d aosta', 'Veneto'];
exports.stateListFromAPI = stateListFromAPI;
var provinceList = {
  FM: 'Fermo',
  BT: 'Barletta-Andria-Trani',
  VT: 'Viterbo',
  LU: 'Lucca',
  VR: 'Verona',
  LT: 'Latina',
  VS: 'Medio-Campidano',
  LO: 'Lodi',
  VI: 'Vicenza',
  VE: 'Venezia',
  VC: 'Vercelli',
  ME: 'Messina',
  VB: 'Verbano-Cusio-Ossola',
  VA: 'Varese',
  MI: 'Milano',
  MC: 'Macerata',
  MB: 'Monza e Brianza',
  FE: 'Ferrara',
  FC: 'Forlì-Cesena',
  MN: 'Mantova',
  MO: 'Modena',
  MT: 'Matera',
  MS: 'Massa-Carrara',
  EN: 'Enna',
  UD: 'Udine',
  NA: 'Napoli',
  TV: 'Treviso',
  GE: 'Genova',
  NU: 'Nuoro',
  NO: 'Novara',
  FR: 'Frosinone',
  OG: 'Ogliastra',
  FG: 'Foggia',
  FI: 'Firenze',
  OT: 'Olbia-Tempio',
  OR: 'Oristano',
  PN: 'Pordenone',
  PO: 'Prato',
  GR: 'Grosseto',
  PI: 'Pisa',
  GO: 'Gorizia',
  PD: 'Padova',
  PE: 'Pescara',
  VV: 'Vibo-Valentia',
  PG: 'Perugia',
  PA: 'Palermo',
  PC: 'Piacenza',
  RI: 'Rieti',
  RG: 'Ragusa',
  RE: 'Reggio Emilia',
  RC: 'Reggio di Calabria',
  RO: 'Rovigo',
  RN: 'Rimini',
  RM: 'Roma',
  RA: 'Ravenna',
  AT: 'Asti',
  AR: 'Arezzo',
  AQ: 'L\'Aquila',
  IM: 'Imperia',
  AV: 'Avellino',
  IS: 'Isernia',
  BA: 'Bari',
  PT: 'Pistoia',
  PU: 'Pesaro-Urbino',
  PV: 'Pavia',
  AG: 'Agrigento',
  PR: 'Parma',
  AL: 'Alessandria',
  AO: 'Aosta',
  AP: 'Ascoli-Piceno',
  PZ: 'Potenza',
  AN: 'Ancona',
  TE: 'Teramo',
  BS: 'Brescia',
  BR: 'Brindisi',
  TO: 'Torino',
  TN: 'Trento',
  CB: 'Campobasso',
  CA: 'Cagliari',
  TS: 'Trieste',
  TR: 'Terni',
  BZ: 'Bolzano',
  TP: 'Trapani',
  SV: 'Savona',
  BG: 'Bergamo',
  SS: 'Sassari',
  BI: 'Biella',
  BN: 'Benevento',
  BO: 'Bologna',
  BL: 'Belluno',
  TA: 'Taranto',
  CZ: 'Catanzaro',
  KR: 'Crotone',
  CT: 'Catania',
  CS: 'Cosenza',
  SI: 'Siena',
  SP: 'La Spezia',
  SO: 'Sondrio',
  SR: 'Siracusa',
  CI: 'Carbonia-Iglesias',
  LC: 'Lecco',
  CH: 'Chieti',
  CE: 'Caserta',
  LI: 'Livorno',
  CR: 'Cremona',
  CO: 'Como',
  LE: 'Lecce',
  CN: 'Cuneo',
  SA: 'Salerno',
  CL: 'Caltanissetta',
  SU: 'Sud Sardegna'
};
exports.provinceList = provinceList;
var inverseProvinceList = {
  agrigento: 'ag, sicilia',
  alessandria: 'al, piemonte',
  ancona: 'an, marche',
  aosta: 'ao, valle d\'aosta',
  arezzo: 'ar, toscana',
  'ascoli-piceno': 'ap, marche',
  asti: 'at, piemonte',
  avellino: 'av, campania',
  bari: 'ba, puglia',
  'barletta-andria-trani': 'bt, puglia',
  belluno: 'bl, veneto',
  benevento: 'bn, campania',
  bergamo: 'bg, lombardia',
  biella: 'bi, piemonte',
  bologna: 'bo, emilia-romagna',
  bolzano: 'bz, trentino-alto adige',
  brescia: 'bs, lombardia',
  brindisi: 'br, puglia',
  cagliari: 'ca, sardegna',
  caltanissetta: 'cl, sicilia',
  campobasso: 'cb, molise',
  'carbonia-iglesias': 'ci, sardegna',
  caserta: 'ce, campania',
  catania: 'ct, sicilia',
  catanzaro: 'cz, calabria',
  chieti: 'ch, abruzzo',
  como: 'co, lombardia',
  cosenza: 'cs, calabria',
  cremona: 'cr, lombardia',
  crotone: 'kr, calabria',
  cuneo: 'cn, piemonte',
  enna: 'en, sicilia',
  fermo: 'fm, marche',
  ferrara: 'fe, emilia-romagna',
  firenze: 'fi, toscana',
  foggia: 'fg, puglia',
  'forli-cesena': 'fc, emilia-romagna',
  frosinone: 'fr, lazio',
  genova: 'ge, liguria',
  gorizia: 'go, friuli-venezia giulia',
  grosseto: 'gr, toscana',
  imperia: 'im, liguria',
  isernia: 'is, molise',
  'l-aquila': 'aq, abruzzo',
  'la-spezia': 'sp, liguria',
  latina: 'lt, lazio',
  lecce: 'le, puglia',
  lecco: 'lc, lombardia',
  livorno: 'li, toscana',
  lodi: 'lo, lombardia',
  lucca: 'lu, toscana',
  macerata: 'mc, marche',
  mantova: 'mn, lombardia',
  'massa-carrara': 'ms, toscana',
  matera: 'mt, basilicata',
  'medio-campidano': 'vs, sardegna',
  messina: 'me, sicilia',
  milano: 'mi, lombardia',
  modena: 'mo, emilia-romagna',
  'monza-e-della-brianza': 'mb, lombardia',
  napoli: 'na, campania',
  novara: 'no, piemonte',
  nuoro: 'nu, sardegna',
  ogliastra: 'og, sardegna',
  'olbia-tempio': 'ot, sardegna',
  oristano: 'or, sardegna',
  padova: 'pd, veneto',
  palermo: 'pa, sicilia',
  parma: 'pr, emilia-romagna',
  pavia: 'pv, lombardia',
  perugia: 'pg, umbria',
  'pesaro-urbino': 'pu, marche',
  pescara: 'pe, abruzzo',
  piacenza: 'pc, emilia-romagna',
  pisa: 'pi, toscana',
  pistoia: 'pt, toscana',
  pordenone: 'pn, friuli-venezia giulia',
  potenza: 'pz, basilicata',
  prato: 'po, toscana',
  ragusa: 'rg, sicilia',
  ravenna: 'ra, emilia-romagna',
  'reggio-di-calabria': 'rc, calabria',
  'reggio-nell-emilia': 're, emilia-romagna',
  rieti: 'ri, lazio',
  rimini: 'rn, emilia-romagna',
  roma: 'rm, lazio',
  rovigo: 'ro, veneto',
  salerno: 'sa, campania',
  sassari: 'ss, sardegna',
  savona: 'sv, liguria',
  siena: 'si, toscana',
  siracusa: 'sr, sicilia',
  sondrio: 'so, lombardia',
  taranto: 'ta, puglia',
  teramo: 'te, abruzzo',
  terni: 'tr, umbria',
  torino: 'to, piemonte',
  trapani: 'tp, sicilia',
  trento: 'tn, trentino-alto adige',
  treviso: 'tv, veneto',
  trieste: 'ts, friuli-venezia giulia',
  udine: 'ud, friuli-venezia giulia',
  varese: 'va, lombardia',
  venezia: 've, veneto',
  'verbano-cusio-ossola': 'vb, piemonte',
  vercelli: 'vc, piemonte',
  verona: 'vr, veneto',
  'vibo-valentia': 'vv, calabria',
  vicenza: 'vi, veneto',
  viterbo: 'vt, lazio'
};
var atticoZonesToCasaZones = {
  // BOLOGNA
  18: ['Z-29717'],
  19: ['Z-29726'],
  20: ['Z-29718'],
  21: ['Z-29725'],
  22: ['Z-29723'],
  23: ['Z-29722', 'Z-5587'],
  24: ['Z-29724'],
  25: ['Z-29714'],
  26: ['Z-29719', 'Z-29720'],
  27: ['Z-29715'],
  28: ['Z-29721'],
  29: ['Z-5582'],
  30: ['Z-29728'],
  31: ['Z-29728'],
  32: ['Z-29730'],
  33: ['Z-29716', 'Z-29729', 'Z-5580'],
  34: ['Z-29727'],
  35: ['Z-29732'],
  37: ['Z-29716'],
  286: ['Z-29713'],
  // FIRENZE
  47: ['Z-30855', 'Z-30876'],
  48: ['Z-30876', 'Z-30879', 'Z-30460'],
  49: ['Z-30458'],
  50: ['Z-30457', 'Z-30458', 'Z-30852'],
  51: ['Z-30851', 'Z-30852', 'Z-30853', 'Z-30867'],
  52: ['Z-30853', 'Z-30867', 'Z-30659'],
  53: ['Z-30855'],
  54: ['Z-30866'],
  55: ['Z-10375'],
  56: ['Z-31657', 'Z-30864', 'Z-30857', 'Z-30858', 'Z-30860'],
  57: ['Z-30857', 'Z-30865'],
  58: ['Z-30452', 'Z-30867'],
  60: ['Z-30876'],
  61: ['Z-10375', 'Z-30458'],
  62: ['Z-10375'],
  63: ['Z-30851', 'Z-30852', 'Z-30867'],
  64: ['Z-30857', 'Z-30865'],
  65: ['Z-30859'],
  66: ['Z-30857', 'Z-30858', 'Z-30866'],
  // MILANO
  89: ['Z-30776'],
  90: ['Z-30754'],
  91: ['Z-30755'],
  92: ['Z-30770'],
  93: ['Z-30769'],
  94: ['Z-30756'],
  95: ['Z-30757'],
  96: ['Z-30772'],
  97: ['Z-30758'],
  98: ['Z-30759'],
  99: ['Z-30760'],
  100: ['Z-30767'],
  101: ['Z-30765'],
  102: ['Z-30766'],
  103: ['Z-30768'],
  104: ['Z-30761'],
  105: ['Z-30762'],
  106: ['Z-30763'],
  107: ['Z-30764'],
  // MONZA
  108: ['Z-31047'],
  109: ['Z-31049'],
  110: ['Z-31046'],
  111: ['Z-31048'],
  112: ['Z-31045'],
  113: ['Z-31044'],
  114: ['Z-31043'],
  // NAPOLI
  115: ['Z-30704', 'Z-30715', 'Z-30717'],
  116: ['Z-30701', 'Z-30707', 'Z-30709', 'Z-30714'],
  117: ['Z-30716', 'Z-30724'],
  118: ['Z-30719', 'Z-30712', 'Z-30725', 'Z-30727'],
  119: ['Z-30700', 'Z-30726'],
  120: ['Z-30703', 'Z-30713', 'Z-30718'],
  121: ['Z-30708', 'Z-30720', 'Z-30722'],
  122: ['Z-30705', 'Z-30711', 'Z-30721'],
  123: ['Z-30710', 'Z-30723'],
  124: ['Z-30702', 'Z-30706'],
  // PADOVA
  139: ['Z-30528', 'Z-30907', 'Z-30996', 'Z-31661'],
  140: ['Z-30533', 'Z-30965', 'Z-30994', 'Z-30933', 'Z-30527', 'Z-30524', 'Z-31921', 'Z-31000', 'Z-30931', 'Z-30980', 'Z-30919'],
  141: ['Z-30914', 'Z-30927', 'Z-30534', 'Z-30525', 'Z-30932', 'Z-30965'],
  142: ['Z-30941', 'Z-30530', 'Z-30914', 'Z-30974', 'Z-30979'],
  143: ['Z-30903', 'Z-30918', 'Z-30902', 'Z-30975', 'Z-30531', 'Z-30532', 'Z-30942'],
  311: ['Z-30522', 'Z-30526', 'Z-30527', 'Z-30902', 'Z-30911', 'Z-30922', 'Z-30929', 'Z-30939', 'Z-30942', 'Z-30945', 'Z-30959', 'Z-30970', 'Z-30971', 'Z-30973', 'Z-30974', 'Z-30989', 'Z-30990', 'Z-30991', 'Z-30992'],
  // PRATO
  187: ['Z-30803'],
  188: ['Z-30807'],
  189: ['Z-30829', 'Z-31929', 'Z-30834', 'Z-30850'],
  190: ['Z-30824', 'Z-30825'],
  191: ['Z-30812', 'Z-30841', 'Z-30820'],
  192: ['Z-20264', 'Z-30818'],
  193: ['Z-30805', 'Z-30833'],
  194: ['Z-20269', 'Z-30830', 'Z-30848'],
  195: ['Z-20267', 'Z-30843'],
  196: ['Z-30816', 'Z-20273', 'Z-31104'],
  197: ['Z-30837'],
  198: ['Z-20261'],
  199: ['Z-20268', 'Z-30827', 'Z-30844', 'Z-30845'],
  200: ['Z-20272'],
  201: ['Z-20262', 'Z-20266'],
  // ROMA
  202: ['Z-29440'],
  203: ['Z-29417', 'Z-29431'],
  204: ['Z-29425'],
  205: ['Z-29415'],
  206: ['Z-29466'],
  207: ['Z-29466'],
  208: ['Z-29445'],
  209: ['Z-29490'],
  210: ['Z-29490', 'Z-29463'],
  211: ['Z-29463'],
  212: ['Z-29463'],
  213: ['Z-29435'],
  214: ['Z-29435'],
  215: ['Z-29445'],
  216: ['Z-29402'],
  217: ['Z-29402'],
  218: ['Z-29458'],
  219: ['Z-29404', 'Z-29496'],
  220: ['Z-29404'],
  221: ['Z-29416'],
  222: ['Z-29496'],
  223: ['Z-29496', 'Z-31837'],
  224: ['Z-29478', 'Z-29430'],
  225: ['Z-29411'],
  226: ['Z-29458'],
  227: ['Z-29405'],
  228: ['Z-29478', 'Z-29405', 'Z-29468'],
  229: ['Z-29468'],
  230: ['Z-29424', 'Z-29431', 'Z-29424'],
  231: ['Z-29407'],
  232: ['Z-29469', 'Z-30774'],
  233: ['Z-29431'],
  234: ['Z-31511'],
  235: ['Z-29466', 'Z-31916'],
  236: ['Z-29485'],
  237: ['Z-31768', 'Z-31771'],
  238: ['Z-31617'],
  239: ['Z-29488', 'Z-31510', 'Z-31770'],
  240: ['Z-29471'],
  242: ['Z-29468', 'Z-31660'],
  243: ['Z-29469', 'Z-30774'],
  318: ['Z-29404', 'Z-31510'],
  319: ['Z-31837', 'Z-31770', 'Z-31510'],
  320: ['Z-31660'],
  321: ['Z-29480'],
  322: ['Z-29420'],
  // TORINO
  36: ['Z-30734'],
  245: ['Z-30174'],
  246: ['Z-30750'],
  247: ['Z-30744', 'Z-30750'],
  248: ['Z-30180'],
  249: ['Z-30739'],
  250: ['Z-30184'],
  251: ['Z-30182', 'Z-30733'],
  252: ['Z-30735', 'Z-31509', 'Z-30181'],
  253: ['Z-30729'],
  254: ['Z-30747', 'Z-30752'],
  255: ['Z-30730', 'Z-30777', 'Z-30737'],
  256: ['Z-30740', 'Z-30731'],
  257: ['Z-30738'],
  258: ['Z-30179', 'Z-30186'],
  259: ['Z-30177', 'Z-30178'],
  // GENOVA
  287: ['Z-29869'],
  288: ['Z-29891'],
  289: ['Z-29871'],
  290: ['Z-29870'],
  291: ['Z-29873'],
  292: ['Z-29874', 'Z-29872'],
  293: ['Z-31346'],
  294: ['Z-29875'],
  295: ['Z-29885'],
  296: ['Z-31347'],
  297: ['Z-29876'],
  298: ['Z-29877', 'Z-31881'],
  299: ['Z-29879'],
  300: ['Z-31903'],
  301: ['Z-29880'],
  302: ['Z-29882'],
  303: ['Z-29881'],
  304: ['Z-29883', 'Z-29884'],
  305: ['Z-29889'],
  306: ['Z-29886'],
  307: ['Z-29887'],
  308: ['Z-29890'],
  309: ['Z-29878'],
  310: ['Z-29892', 'Z-11354']
};

function convertToCasaZone(atticoZone) {
  return atticoZonesToCasaZones[atticoZone] ? atticoZonesToCasaZones[atticoZone] : [];
}

var mainCityList = [{
  name: 'Milano',
  stateShortName: 'lom',
  stateName: 'Lombardia',
  alias: 'MI'
}, {
  name: 'Torino',
  stateShortName: 'pie',
  stateName: 'Piemonte',
  alias: 'TO'
}, {
  name: 'Roma',
  stateShortName: 'laz',
  stateName: 'Lazio',
  alias: 'RM'
}, {
  name: 'Napoli',
  stateShortName: 'cam',
  stateName: 'Campania',
  alias: 'NA'
}];
var PROVENCE = 'Provence-Alpes-Cote Azur';

function findCityByField(condition, field) {
  for (var index = 0; index < mainCityList.length; index++) {
    if (mainCityList[index][field] === condition) {
      return mainCityList[index];
    }
  }
}

var PROVINCE_IT = '(provincia)';
exports.PROVINCE_IT = PROVINCE_IT;
var CITY_IT = '(comune)';
exports.CITY_IT = CITY_IT;
var CATEGORY_TYPE = {
  ZONE: 'DISTRICT',
  MAIN_CITY: 'MAIN_SUBURB',
  CITY: 'SUBURB',
  PROVINCE: 'PROVINCE',
  STATE: 'STATE',
  STREET: 'STREET',
  REGION: 'REGION',
  POSTAL_CODE: 'POSTAL_CODE',
  FREE_TEXT: 'FREE_TEXT'
};
exports.CATEGORY_TYPE = CATEGORY_TYPE;

function getProvinceFullName(shortName) {
  return provinceList[shortName];
}

function getProvinceAndState(fullName) {
  return inverseProvinceList[fullName.toLowerCase()];
}

function currentStateHasMainCity(stateShortName) {
  return findCityByField(stateShortName, 'stateShortName') !== undefined;
}

function isMainCity(cityName) {
  return findCityByField(cityName, 'name') !== undefined;
}

function getMainCityStateShortName(cityName) {
  var city = findCityByField(cityName, 'name');
  return city !== undefined ? city.stateShortName : '';
}

function getMainCityList() {
  return mainCityList;
}

function parseLocation(locationStr) {
  var locationObj = {
    realValue: locationStr,
    searchValue: locationStr,
    displayValue: locationStr
  };
  var locationArray = splitLocationStr(locationStr);

  switch (locationArray.length) {
    case 1:
      parseStateLocation(locationObj);
      break;

    case 2:
      parseProvinceLocation(locationObj, locationArray);
      break;

    case 3:
      parseCityLocation(locationObj, locationArray);
      break;

    case 4:
      parseZoneLocation(locationObj, locationArray);
      break;

    default:
      break;
  }

  return locationObj;
}

function splitLocationStr(locationStr) {
  return locationStr.split(',').map(function (location) {
    return location.trim();
  });
}

function parseStateLocation(locationObj) {
  locationObj.category = CATEGORY_TYPE.STATE;
  locationObj.locationType = CATEGORY_TYPE.STATE;
  locationObj.parent = '';
}

function parseCityLocation(locationObj, locationArray) {
  var city = locationArray[0];
  var province = locationArray[1];

  if (!isFranceProvince(province)) {
    locationObj.displayValue = city + ' (' + province + ')';
  } else {
    locationObj.displayValue = city;
  }

  locationObj.parent = locationArray[1];
  locationObj.category = isMainCity(locationObj.realValue) ? CATEGORY_TYPE.MAIN_CITY : CATEGORY_TYPE.CITY;
  locationObj.locationType = isMainCity(locationObj.realValue) ? CATEGORY_TYPE.MAIN_CITY : CATEGORY_TYPE.CITY;
}

function parseZoneLocation(locationObj, locationArray) {
  locationObj.category = CATEGORY_TYPE.ZONE;
  locationObj.locationType = CATEGORY_TYPE.ZONE;
  locationObj.parent = locationArray[1];
  locationObj.displayValue = locationArray[0] + ' (' + locationArray[1] + ')';
}

function parseProvinceLocation(locationObj, locationArray) {
  locationObj.category = CATEGORY_TYPE.PROVINCE;
  locationObj.locationType = CATEGORY_TYPE.PROVINCE;
  locationObj.parent = locationArray[1];
  var provinceFullName = getProvinceFullName(locationArray[0]);

  if (isBelongToProvence(locationObj.displayValue)) {
    locationObj.displayValue = PROVENCE;
  } else if (provinceFullName) {
    locationObj.displayValue = provinceFullName + ' (provincia)';
  }
}

function isFranceProvince(province) {
  return !isNaN(province);
}

function isBelongToProvence(locationStr) {
  return locationStr.indexOf(PROVENCE) > -1;
}

var TorinoMainDistricts = [{
  displayValue: 'Centro/ Giardini Reali/ Repubblica, Torino, TO, Piemonte',
  locality: 'Centro/ Giardini Reali/ Repubblica',
  subdivision: 'PIEMONTE',
  value: '1737',
  type: 'DISTRICT',
  alias: 'Centro/ Giardini Reali/ Repubblica'
}, {
  displayValue: 'Santa Rita, Torino, TO, Piemonte',
  locality: 'Santa Rita',
  subdivision: 'PIEMONTE',
  value: '809',
  type: 'DISTRICT',
  alias: 'Santa Rita'
}, {
  displayValue: 'Barriera Milano, Torino, TO, Piemonte',
  locality: 'Barriera Milano',
  subdivision: 'PIEMONTE',
  value: '764',
  type: 'DISTRICT',
  alias: 'Barriera Milano'
}, {
  displayValue: 'Crocetta, Torino, TO, Piemonte',
  locality: 'Crocetta',
  subdivision: 'PIEMONTE',
  value: 629,
  type: 'DISTRICT',
  alias: 'Crocetta'
}, {
  displayValue: 'Parella, Torino, TO, Piemonte',
  locality: 'Parella',
  subdivision: 'PIEMONTE',
  value: '672',
  type: 'DISTRICT',
  alias: 'Parella'
}];
exports.TorinoMainDistricts = TorinoMainDistricts;
var MilanoMainDistricts = [{
  displayValue: 'Centro Storico/ Brera, Milano, MI, Lombardia',
  locality: 'Centro Storico/ Brera',
  subdivision: 'LOMBARDIA',
  value: '4217',
  type: 'DISTRICT',
  alias: 'Centro Storico/ Brera'
}, {
  displayValue: 'Città Studi/ Lambrate/ Udine/ Loreto, Milano, MI, Lombardia',
  locality: 'Città Studi/ Lambrate/ Udine/ Loreto',
  subdivision: 'LOMBARDIA',
  value: '2254',
  type: 'DISTRICT',
  alias: 'Città Studi/ Lambrate/ Udine/ Loreto'
}, {
  displayValue: 'Fiera/ Firenze/ Sempione/ Paolo Sarpi/Arena, Milano, MI, Lombardia',
  locality: 'Fiera/ Firenze/ Sempione/ Paolo Sarpi/Arena',
  subdivision: 'LOMBARDIA',
  value: '2213',
  type: 'DISTRICT',
  alias: 'Fiera/ Firenze/ Sempione/ Paolo Sarpi/Arena'
}, {
  displayValue: 'Greco / Monza / Palmanova/ Bicocca, Milano, MI, Lombardia',
  locality: 'Greco / Monza / Palmanova/ Bicocca',
  subdivision: 'LOMBARDIA',
  value: '1748',
  type: 'DISTRICT',
  alias: 'Greco / Monza / Palmanova/ Bicocca'
}, {
  displayValue: 'Affori/ Bovisa/ Niguarda/ Testi, Milano, MI, Lombardia',
  locality: 'Affori/ Bovisa/ Niguarda/ Testi',
  subdivision: 'LOMBARDIA',
  value: '1495',
  type: 'DISTRICT',
  alias: 'Affori/ Bovisa/ Niguarda/ Testi'
}, {
  displayValue: 'Forlanini/ Umbria/ Lodi/ Corvetto/ Rogoredo, Milano, MI, Lombardia',
  locality: 'Forlanini/ Umbria/ Lodi/ Corvetto/ Rogoredo',
  subdivision: 'LOMBARDIA',
  value: '1449',
  type: 'DISTRICT',
  alias: 'Forlanini/ Umbria/ Lodi/ Corvetto/ Rogoredo'
}];
exports.MilanoMainDistricts = MilanoMainDistricts;
var NapoliMainDistricts = [{
  displayValue: 'Napoli centro, Napoli, NA, Campania',
  locality: 'Napoli centro',
  subdivision: 'CAMPANIA',
  value: '226',
  type: 'DISTRICT',
  alias: 'Napoli centro'
}, {
  displayValue: 'Chiaia / Mergellina, Napoli, NA, Campania',
  locality: 'Chiaia / Mergellina',
  subdivision: 'CAMPANIA',
  value: '662',
  type: 'DISTRICT',
  alias: 'Chiaia / Mergellina'
}, {
  displayValue: 'Vomero/ Vomero Alto, Napoli, NA, Campania',
  locality: 'Vomero/ Vomero Alto',
  subdivision: 'CAMPANIA',
  value: '465',
  type: 'DISTRICT',
  alias: 'Vomero/ Vomero Alto'
}, {
  displayValue: 'Posillipo, Napoli, NA, Campania',
  locality: 'Posillipo',
  subdivision: 'CAMPANIA',
  value: '322',
  type: 'DISTRICT',
  alias: 'Posillipo'
}, {
  displayValue: 'San Carlo Arena / Capodimonte/ Colli Aminei, Napoli, NA, Campania',
  locality: 'San Carlo Arena / Capodimonte/ Colli Aminei',
  subdivision: 'CAMPANIA',
  value: '242',
  type: 'DISTRICT',
  alias: 'San Carlo Arena / Capodimonte/ Colli Aminei'
}];
exports.NapoliMainDistricts = NapoliMainDistricts;